module.exports = __webpack_public_path__ + "static/media/notification-active.bf3031ea.svg";